import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/wrapperStyle';
import classNames from 'classnames';

const Wrapper = (Component: React.FunctionComponent<any>, alignCenter: boolean = false) => (props: any) => {
	const classes = makeStyles(styles)();
	return (
		<div className={classNames({ [classes.wrapper]: true, [classes.alignCenter]: alignCenter })}>
			<Component {...props} />
		</div>
	);
};

export default Wrapper;
